module.exports = "/_next/static/images/convertible-3c45edac1f3ad886618a53434d785387.jpg";